import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import styles from './Dropdown.module.css';

const DropdownButton = ({ children, open, toggle }) => {
  return (
    <div
      onClick={toggle}
      className={`${styles.button} ${open ? styles.buttonOpen : ""}`}
    >
      {children}
      <span
        className={styles.toggleIcon}
        style={{ pointerEvents: "none" }} // This allows clicks to pass through
      >
        {open ? <FaChevronUp /> : <FaChevronDown />}
      </span>
    </div>
  );
};

export default DropdownButton;